import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TaskService } from '../../core/services/task.service';
import { RouterModule, Router } from '@angular/router';
import { TaskFormBaseComponent } from '../task-form-base.component';

@Component({
  selector: 'app-task-create',
  templateUrl: './task-create.component.html',
  styleUrls: ['./task-create.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
})
export class TaskCreateComponent extends TaskFormBaseComponent {
  constructor(
    protected override fb: FormBuilder,
    private taskService: TaskService,
    private router: Router,
  ) {
    super(fb);
  }

  onSubmit(): void {
    if (this.taskForm.valid) {
      this.taskService.createTask(this.taskForm.value).subscribe({
        next: () => {
          this.router.navigate(['/tasks']);
        },
        error: error => {
          console.error('Error al crear la tarea:', error.message);
          this.errorMessage = error.error || 'Ocurrió un error al crear la tarea';
        },
        complete: () => {
          console.log('Solicitud de creación de tarea completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }
}
